
/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

$("iframe#info-window").contents().find("span#size-text").css('font-size', '6px');
jQuery(document).on('mouseenter', '.Header__MainNav .HorizontalList__Item a', function(e) {
    var selectors = jQuery(this).parent('.HorizontalList__Item');
    var firstChild = jQuery(selectors.find('.Linklist').find('.Linklist__Item:first-child'));
    firstChild.addClass('active');
    firstChild.siblings().removeClass('active');

    parentActivated(selectors);
});

jQuery(document).on('mouseenter', '.Header__MainNav .Linklist .Linklist__Item a', function(e) {
    var selectors = jQuery(this);
    var parent_selector = selectors.parents('.HorizontalList__Item');
    var classList = jQuery(selectors).attr('class').split(/\s+/);

    selectors.parent('.Linklist__Item').addClass('active');
    selectors.parent('.Linklist__Item').siblings().removeClass('active');

    var uniq_class = '';
    jQuery.each(classList, function(index, item) {
        if (item.includes("uniq-")) {
            uniq_class = item.replace('uniq-','');
        }
    });
    if (!uniq_class) return;

    if (parent_selector.find('.MegaMenu-images-'+uniq_class).length) {
        parent_selector.find('.MegaMenu__Item').find('.MegaMenu__Push').addClass('hide');
        parent_selector.find('.MegaMenu__Item').find('.MegaMenu-images-'+uniq_class).removeClass('hide');
        parent_selector.find('.MegaMenu__Item').find('.MegaMenu-images-'+uniq_class).removeClass('show');
    } else {
        parentActivated(parent_selector);
    }
});

$(document).ready(function () {
  jQuery('.HorizontalList__Item').each(function(e){
    jQuery(this).mouseleave(function() {
      
//       jQuery(this).parents('.custom_desktop_menu').find('.custom_handle_block').fadeOut('slow');
//       jQuery(this).parents('.custom_desktop_menu').find('.custom_handle_block').animate({ opacity: 0 },200)

//       jQuery(this).parents('.custom_desktop_menu').find('.custom_handle_block').fadeOut(5000);
    });

  });
  
  $('.SectionHeader__Heading').hover(function(){
  	$(this).parents('.CollectionItem').find('.mega_menu_image-overlay').css('opacity','24%');
    $(this).parent().find('.CollectionItem__Link.Button').css({background: "#482922",
    color: "#fff"});
  });
  
  $('.SectionHeader__Heading').on('mouseleave',function(){
  	$(this).parents('.CollectionItem').find('.mega_menu_image-overlay').css('opacity','0');
    $(this).parent().find('.CollectionItem__Link.Button').css({background: "unset",
                                                               color: "unset"});
  });
  
  $('.CollectionItem .CollectionItem__Wrapper').hover(function(){
  	 $(this).parent().find('.CollectionItem__Link.Button').css({background: "#482922",
                                                                color: "#fff"});
  });
  
  $('.CollectionItem .CollectionItem__Wrapper').on('mouseleave',function(){
  	$(this).parent().find('.CollectionItem__Link.Button').css({background: "unset",
                                                                color: "unset"});
  });
 
});

function parentActivated(selectors)
{
    if (selectors.children('.MegaMenu').length) {
        var classList = jQuery(selectors.find('.Linklist').find('.Linklist__Item:first-child a')).attr('class').split(/\s+/);
        var uniq_class = '';
        jQuery.each(classList, function(index, item) {
            if (item.includes("uniq-")) {
                uniq_class = item.replace('uniq-','');
            }
        });
        if (!uniq_class) return;

        if (selectors.find('.MegaMenu-images-'+uniq_class).length) {
            selectors.find('.MegaMenu__Item').find('.MegaMenu__Push').addClass('hide');
            selectors.find('.MegaMenu__Item').find('.MegaMenu-images-'+uniq_class).removeClass('hide');
            selectors.find('.MegaMenu__Item').find('.MegaMenu-images-'+uniq_class).removeClass('show');
        } 
    }
}

$(document).ready(function () {
  if ($(window).width() < 640) {
    $(".Footer__Block--links .Footer__Title").click(function (e) {
      var showElementDescription = 
          $(this).parents(".Footer__Block--links").find("ul");

      $(this).parents(".Footer__Block--links").removeClass('active');
      if ($(showElementDescription).is(":visible")) {
        showElementDescription.hide("fast", "swing");
      } else {
        showElementDescription.show("fast", "swing");
        $(this).parents(".Footer__Block--links").addClass('active');
      }
    });
  }
  $(".Footer__Block--text .Header__LogoLink").click(function (e) {
    e.preventDefault();
    $('#KT_scroll_top').trigger('click');
  });
  
  //   zoom image
  if($(window).width() > 768){
    /*$('.Product__SlideItem').each(function() {
      var url = $(this).find('img').attr('data-zoom'); 
      $(this).find('img').parent().zoom({
          url: url,
        	on: 'mouseover'
        });
    });*/

  }


// diable click on coming soon
function disableClickOnProducts() {
  document.querySelectorAll('.ProductItem__ImageWrapper:has(.disable_click_coming)').forEach((anchor) => {
    anchor.removeAttribute('href');
  });
  document.querySelectorAll('.ProductItem__ImageWrapper:has(.disable_click_coming) + .product--information .ProductItem__Title a').forEach((text) => {
    text.removeAttribute('href');
  });
}

// Run on initial load
$(document).ready(function () {
  disableClickOnProducts();
});

  
  $(document).ready(function() {
	$('.shoppable-content ul').magnificPopup({
		delegate: 'a',
		type: 'image',
		tLoading: 'Loading image #%curr%...',
		mainClass: 'mfp-img-mobile',
		gallery: {
			enabled: true,
			navigateByImgClick: true,
			preload: [0,1] // Will preload 0 - before current, and 1 after the current image
		},
		image: {
			tError: '<a href="%url%">The image #%curr%</a> could not be loaded.',
			titleSrc: function(item) {
				return item.el.attr('title') + '<small>by Marsel Van Oosten</small>';
			}
		}
	});
});

  /*$('.image-container .zoom').on('click', function(){
    $(this).toggleClass('clicked');
    $(this).mouseleave(function(){
      if($(this).hasClass('clicked') == true){
        $(this).trigger( "click" );        
      }
    });
  });
   $('.image-container .zoom').on('hover', function(){
    $(this).toggleClass('clicked');
    $(this).mouseleave(function(){
      if($(this).hasClass('clicked') == true){
        $(this).trigger( "click" );        
      }
    });
  });
*/
  
 $('.ProductItem__ImageWrapper--withAlternateImage').on("touchstart" ,function(event) {
    
   if($(this).closest(".swiper-wrapper").length > 0){
     console.log('d')
   } else {
    setTimeout(() => {
      event.stopPropagation();
      $(this).addClass("showhover_image");
    }, 100);
   }
  });
  
  $('.ProductItem__ImageWrapper--withAlternateImage').on("touchend" ,function(event) {
      if($(this).closest(".swiper-wrapper").length > 0){
   } else {
      event.stopPropagation();
    $(this).removeClass("showhover_image");
   }
  });
  
  var sticky_bar = document.getElementById('shopify-section-countdown');
  var countbar_true = $('#section-countdown').data('sticky-true');
  
  if(countbar_true) {
    $('#shopify-section-header').css("top",sticky_bar.offsetHeight+'px');
  }else {
   $('#shopify-section-header').css("top","0");
  }
  
  // black friday
  
  var today = new Date().getTime();
//   var utc_time  = today.toUTCString();
  var final_date = new Date('Nov 23, 2021 20:00:00 UTC').getTime();
//   var date = today.getDate()+'-'+(today.getMonth()+1)+'-'+today.getFullYear();
 
  if(today > final_date) {
    $('#shopify-section-above-footer').css("display","block");
    $('.black-friday-another-product-hide').show();
    
  } else {
	
    $('.black-friday-secc').addClass('black-friday-section-products-hidding');  
    // Set the date we're counting down to
    var countDownDate = new Date("Nov 23, 2021 20:00:00 UTC").getTime();

    // Update the count down every 1 second
    var x = setInterval(function() {

      // Get today's date and time
      var now = new Date().getTime();

      // Find the distance between now and the count down date
      var distance = countDownDate - now;

      // Time calculations for days, hours, minutes and seconds
      var days = Math.floor(distance / (1000 * 60 * 60 * 24));
      var fdays = ("0" + days).slice(-2);
      var hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      var fhours = ("0" + hours).slice(-2);
      var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      var fminutes = ("0" + minutes).slice(-2);
      var seconds = Math.floor((distance % (1000 * 60)) / 1000);
      var fseconds = ("0" + seconds).slice(-2);

      // Output the result in an element with id="demo"
      if(distance > 0) {
      document.getElementById("demo").innerHTML = fdays + ":" + fhours + ":"
      + fminutes + ":" + fseconds;

      document.getElementById("demo2").innerHTML = fdays + ":" + fhours + ":"
      + fminutes + ":" + fseconds;
      }
      // If the count down is over, write some text 
      if (distance < 0) {
        var today = new Date().getTime();
        var final_date = new Date('Nov 23, 2021 20:00:00 UTC').getTime();
        if(today > final_date) {
          location.reload();
        }
        clearInterval(x);
      }
    }, 1000);

    //     console.log("None")
    $('.Gif-Image').removeClass('Black-Friday-hide');
    $('#shopify-section-above-footer').css("display","none");


    $('.black-friday-collection').css("display","none");
    //     $('.black-friday-product-hide').css("display","none");
  }      

});

function addItemToCart(variant_id, qty , tit, shoe_var) {
  if (!variant_id) return;
  console.log(shoe_var, 'shoe_var', 'tit', tit)
  if(shoe_var && tit != ''){
  var properties =   {
    "Size":  tit  + ' | ' + shoe_var
  } 
  }
  data = {
    "id": variant_id,
    "quantity": qty,
    "title": tit,
    "properties" : properties
  }
  jQuery.ajax({
    type: 'POST',
    url: '/cart/add.js',
    data: data,
    dataType: 'json',
    success: function(response) { 
      console.log(data)
      document.documentElement.dispatchEvent(new CustomEvent('product:added', {
        bubbles: true,
        detail: response
      }));
    }   
    
  }); 
 
}


jQuery(document).on('click', '.GridLay .SizeSwatch', function(e) {
  
  e.preventDefault();
  var ID = jQuery(this).parent('li').find('a').attr("data-vari");
  var Shoe =  jQuery(this).parent('li').find('a').attr("data-currentCountry")
  var TITLE = jQuery(this).parent('li').find('a').attr(`data-${Shoe}`);
  console.log(TITLE, "title")
  var _This = jQuery(this);
  if( jQuery(this).parents(".swiper-wrapper")){
    if (_This.closest(".HorizontalList__Item.avail").length) {
      _This.parents(".GridLay").removeClass('drag-swatch');
    }
    setTimeout(function(){
     
        _This.parents(".swiper-wrapper").removeClass('transform__none-item')
     _This.parents(".swiper-slide").removeClass('transform__none-item')
       _This.parents(".swiper-wrapper").css('position','relative');
       _This.parents(".swiper").css('position','relative');
        
    }, 500);
    
  }
 // console.log(ID);
  addItemToCart( ID, 1 , TITLE, Shoe);
});

jQuery(document).on('click', '.plus-icon.one-size', function(e) {
    e.preventDefault();
    var ID = jQuery(this).parent('h2').siblings(".SizeSwatchList").find('a').attr("data-vari");
    var Shoe =  jQuery(this).parent('li').find('a').attr("data-currentCountry")
    var TITLE = jQuery(this).parent('li').find('a').attr(`data-${Shoe}`);
    
    addItemToCart( ID, 1 , TITLE, Shoe);
})
$(document).ready(function() {
  // Iterate over each element with the class 'message-bar--inner'
  $('.message-bar--inner').each(function() {
    // Get the current element in the loop
    var $this = $(this);
    var message_speed = $this.data('slidingspeed');

    // Check if there are multiple messages in this specific section
    if ($this.find('.message').length > 1) {
      $this.flickity({
        contain: true,
        wrapAround: true,
        draggable: false,
        prevNextButtons: false,
        pageDots: false,
        autoPlay: true,
        groupCells: 1,
        cellAlign: 'center',
        fade: true,
        autoPlay: message_speed, // Use the sliding speed for this specific element
      });
    }
  });
});


  
var slide_speed = $('.quote_block').data('slidingspeed');
// console.log(slide_speed);
$('.quote_block').flickity({
//   contain: true,
//   draggable: false,
//   prevNextButtons: false,
//   pageDots: false,
//   autoPlay: true,
//   groupCells: 1,
//   cellAlign: 'center',
//   fade: true,
//   autoPlay: slide_speed
  cellAlign: "center", 
  contain: true, 
  pageDots: false, 
  prevNextButtons: false,
  prevNextBttons: false, 
  autoPlay: slide_speed,
  pauseAutoPlayOnHover: false
});

// Password collection
function setCookie(name, value, days) {
  var expires = '';
  if (days) {
    var date = new Date();
    date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
    expires = '; expires=' + date.toUTCString();
  }
  document.cookie = name + '=' + value + expires + '; path=/';
}

function getCookie(name) {
  var nameEQ = name + '=';
  var cookies = document.cookie.split(';');
  for (var i = 0; i < cookies.length; i++) {
    var cookie = cookies[i];
    while (cookie.charAt(0) === ' ') {
      cookie = cookie.substring(1, cookie.length);
    }
    if (cookie.indexOf(nameEQ) === 0) {
      return cookie.substring(nameEQ.length, cookie.length);
    }
  }
  return null;
}
var pass = $('.js-collection-psw').attr('data-pass');
  if(pass) { 
    if (!getCookie('collectionPassword')) {
    
      $('.js-collection-hide').hide();
      $('html').addClass('no-scroll');
      $('.js-collection-psw form.protected-form input').on('change', function() {
        if(btoa($(this).val()) == pass) {
          passwordFunction();
        } else {
          $('.js-collection-psw').show();
          // $('.wrong_pass_alert').removeClass('hide');
        }
      })
      
      $(".js-collection-psw form.protected-form").submit(function(e){
        e.preventDefault();
        console.log('form.protected-form')
        if(btoa($(this).find('input').val()) == pass) {
          passwordFunction();
        } else {
          $('.js-collection-psw').show();
           $('.wrong_pass_alert').removeClass('hide');
        }
      });
    } else {
      $('.js-collection-psw').hide();
    $('.js-collection-hide').show();
    $('html').removeClass('no-scroll');
    }
  } 

function passwordFunction()
{
  var days = $('.js-collection-psw').attr('data-days');
  setCookie('collectionPassword', 'yes', parseInt(days));
  
  $('#correct_video').show();
  $('.collection-psw__relative').hide();
  let video;
  if($(window).width() > 768){
    video = document.querySelector('#correct_video .video_desktop video');
  } else {
    video = document.querySelector('#correct_video .video_mobile video');
  }
  // Function to show the rest of the page
  function showRestOfPage() {
    console.log('called video finish');
    $('.js-collection-psw').hide();
    $('.js-collection-hide').show();
    $('html').removeClass('no-scroll');
    $('html, body').animate({ scrollTop: 0 }, 0);
  }

  // Check if video exists
  if (video) {
    // Listen for the 'ended' event on the video element
    video.addEventListener('ended', showRestOfPage);
  } else {
    // If no video, directly call showRestOfPage
    showRestOfPage();
  }
}
// Init a timeout variable to be used below
let timeout = null;

// Country Selector Popup

// remove editable func. from product detail 

document.addEventListener("DOMContentLoaded", function() {
  // Select the container with the content
  const contentContainer = document.querySelector('.Collapsible__Inner .Collapsible__Content .Rte');
  if(contentContainer){

    // Select all elements with contenteditable="true"
    const editableElements = contentContainer.querySelectorAll('[contenteditable="true"]');
    
    // Remove the contenteditable attribute from each element
    editableElements.forEach(element => {
        element.removeAttribute('contenteditable');
    });
  }
});




// scrolling promotion section

theme.initWhenVisible = function(options) {
  const threshold = options.threshold ? options.threshold : 0;

  const observer = new IntersectionObserver((entries, observer) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        if (typeof options.callback === 'function') {
          options.callback();
          observer.unobserve(entry.target);
        }
      }
    });
  }, {rootMargin: `0px 0px ${threshold}px 0px`});

  observer.observe(options.element);
};
  
class ScrollingPromotion extends HTMLElement {
  constructor() {
    super();

    this.config = {
      moveTime: parseFloat(this.dataset.speed), // 100px going to move for
      space: 100, // 100px
    };

    this.promotion = this.querySelector('.promotion');

    theme.initWhenVisible({
      element: this,
      callback: this.init.bind(this),
      threshold: 600
    });
  }

  init() {
    if (this.childElementCount === 1) {
      this.promotion.classList.add('promotion--animated');

      for (let index = 0; index < 10; index++) {
        this.clone = this.promotion.cloneNode(true);
        this.clone.setAttribute('aria-hidden', true);
        this.appendChild(this.clone);

        const imageWrapper = this.clone.querySelector('.media-wrapper');
        if (imageWrapper) {
          imageWrapper.classList.remove('loading');
        }
      }

      const animationTimeFrame = (this.promotion.clientWidth / this.config.space) * this.config.moveTime;
      this.style.setProperty('--duration', `${animationTimeFrame}s`);

      // pause when out of view
      const observer = new IntersectionObserver((entries, _observer) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            this.scrollingPlay();
          } else {
            this.scrollingPause();
          }
        });
      }, {rootMargin: '0px 0px 50px 0px'});

      observer.observe(this);
    }
  }
  
  scrollingPlay() {
    this.classList.remove('scrolling-promotion--paused');
  }
  
  scrollingPause() {
    this.classList.add('scrolling-promotion--paused');
  }
}
customElements.define('scrolling-promotion', ScrollingPromotion);
